<template>
    <div :class='classObj' class='SelectMultiArrows row'  >
        <div class='Select1 col-6' :key="resetIdx+'_idx1'"> 
            <label v-if='label1'>{{ label1 }}</label>
            <select multiple :id='name1' :name='name1' :key='getKey1' :disabled='isDisabled' @focus='validate'  @blur='validate'>
                <option v-for='(option, idx) in selectValue' :key='idx' :value='option.value' >{{option.label}}</option>
            </select>
        </div>
        <div class='ArrowButtons'>
            <button class='RemoveExtra' @click='removeExtra(name2, name1)'>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                </svg>
            </button>
            <button class='AddExtra' @click='addExtra(name1, name2)'>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                </svg>
            </button>
        </div>
        <div class='Select2 col-6' :key="resetIdx+'_idx2'" >   
            <label v-if='label2'>{{ label2 }}</label>
            <select multiple :id='name2' :name='name2' :key='getKey2' :disabled='isDisabled' @focus='validate' @blur='validate'> 
                <option v-for='(option, idx2) in selectValue2' :key='idx2' :value='option.value'>{{option.label}}</option>
            </select>
            <span class='validationMessage'>{{ validationMessage }}</span>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'SelectMultiArrows',
        props: ['name1', 'name2', 'store', 'options1', 'options2', 'label1', 'label2', 'disabled', 'hasErrors'],
        data(){ return {
            validationMessages: [],
            availableOptions: this.$store.getters[this.$props.store + '/' + this.$props.name1],
            selectedOptions: this.$store.getters[this.$props.store + '/' + this.$props.name2],
            resetIdx: 0
        }},
        computed:{
            classObj() {
                return{
                    Select: true,
                    'has-error': this.valid == false,
                    'has-success': this.valid == true,
                    'is-disabled': this.isDisabled == true,
                    'is-focused': this.isFocused == true
                }
            },
            selectValue: {
                get () { 
                    return this.$store.getters[this.$props.store + '/' + this.$props.name1]; },
                set (value) { 
                    return this.$store.dispatch(this.$props.store + '/set', {field: this.$props.name1, value}) 
                    },
            },
            selectValue2: {
                get () { 
                    return this.$store.getters[this.$props.store + '/' + this.$props.name2] },
                set (value) { 
                    return this.$store.dispatch(this.$props.store + '/set', {field: this.$props.name2, value}) 
                },
            },
            getKey1(){ return this.$props.store + '_' + this.$props.name1 },
            getKey2(){ return this.$props.store + '_' + this.$props.name2 },
            isDisabled() { return this.$props.disabled || false },
            valid(){ return this.validationMessages.length == 0 ? true : false },
            isValid() { return this.valid },
            validationMessage() { return this.validationMessages.join(', ') }
        },
        methods: {
            validate(e) {
                if(e.type == 'focus') this.isFocused = true;
                if(e.type == 'blur') this.isFocused = false;
                var rules = this.$props.validationRules || [];
                this.validationMessages = [];
                rules.forEach(rule => {
                    switch(rule){
                        case 'required':
                            if(!this.selectValue) this.valid = false
                            this.validationMessages.push('This field is required')
                        break;
                    }
                })
                this.$emit('validationFailed', { field: this.$props.name2, status: this.valid})
            },
            removeExtra(fromId, toId){
                var fromEl = document.getElementById( fromId ),
                    toElOptions = document.getElementById( toId ).options;
                let tempObj = [];
                if ( fromEl.selectedIndex >= 0 ) {
                    var index = toElOptions.length;
                    for ( var i = 0; i < fromEl.options.length; i++ ) {
                        if ( fromEl.options[ i ].selected ) {
                            toElOptions[ index ] = fromEl.options[ i ];
                            this.availableOptions[ index ] = (this.availableOptions.findIndex(x=> x.value == toElOptions[ index ].value) == -1) ? 
                                this.selectedOptions[this.selectedOptions.findIndex(x => x.value == toElOptions[ index ].value)] : 
                                this.availableOptions[ index ];
                            i--;
                            index++
                        }
                    }
                    this.selectValue = this.availableOptions.sort((a, b) => a.value - b.value );
                    this.resetIdx--;
                }
                for ( var i = 0; i < fromEl.options.length; i++ ) {
                    if(tempObj.findIndex(x=> x.value == fromEl.options[ i ].value) == -1){
                        tempObj[i] = this.selectedOptions[this.selectedOptions.findIndex(x => x.value == fromEl.options[ i ].value)];
                    }
                }
                this.selectedOptions = tempObj.sort((a, b) => a.value - b.value );
                this.selectValue2 = this.selectedOptions
            },
            addExtra(fromId, toId){
                var fromEl = document.getElementById( fromId ),
                    toElOptions = document.getElementById( toId ).options;
                let tempObj = [];
                if ( fromEl.selectedIndex >= 0 ) {
                    var index = toElOptions.length;
                    for ( var i = 0; i < fromEl.options.length; i++ ) {
                        if ( fromEl.options[ i ].selected ) {
                            toElOptions[ index ] = fromEl.options[ i ];
                                this.selectedOptions[index] = (this.selectedOptions.findIndex(x=> x.value == toElOptions[ index ].value) == -1) ? 
                                    this.availableOptions[this.availableOptions.findIndex(x => x.value == toElOptions[ index ].value)] :
                                    this.availableOptions[ index ]
                            i--;
                            index++
                        }
                    }
                    this.selectValue2 = this.selectedOptions.sort((a, b) => a.value - b.value );
                    this.resetIdx++;
                }
                for ( var i = 0; i < fromEl.options.length; i++ ) {
                    if(tempObj.findIndex(x=> x.value == fromEl.options[i].value) == -1){
                        tempObj[i] = this.availableOptions[this.availableOptions.findIndex(x => x.value == fromEl.options[i].value)];
                    }
                }
                this.availableOptions = tempObj.sort((a, b) => a.value - b.value );
                this.selectValue = this.availableOptions
            }
        }
    }
</script>
